export default Object.freeze({
  UNSET: -1,
  APPLICANT_INFORMATION: 1,
  RESPONSIBLE_INFORMATION: 2,
  RESEARCH_INFORMATION: 3,
  RESEARCH_OBJECTIVES: 4,
  DOCUMENT_VALIDATION: 5,
  TERMS_AND_CONDITIONS: 6,
  REQUEST_CONFIRMATION: 7,
});
